import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/Slices/modalSlice';
import './scss/ZoobbePremiumCard.scss';
import Payments from '../icons/Payments';

const ZoobbePremiumCard = ({ workspaceId, planType = 'Premium' }) => {
    const dispatch = useDispatch();

    const handleStartTrial = (e) => {
        e.preventDefault();
        dispatch(openModal({
            modalType: 'START_TRIAL',
            modalData: { workspaceId, planType }
        }));
    };

    return (
        <div className="zoobbe-premium-card">
            <h3 className="title">Try Zoobbe Premium</h3>
            <p className="description">
                Unlock advanced features, unlimited boards, and enhanced collaboration tools.
                Get unlimited storage and priority support to take your
                workspace to the next level.
            </p>
            <a href="#" onClick={handleStartTrial} className="start-trial-link">
                Start free trial
            </a>
            <div className="icon-container">
                <Payments />
            </div>
        </div>
    );
};

export default ZoobbePremiumCard;
